import { getRoot, types } from 'mobx-state-tree'
import { RootModel } from '@shared/data-access'

export const MODEL_NAME = 'PDFGenericAnalysis'

export const Model = RootModel.named(MODEL_NAME)
  .props({
    id: types.identifier,
    sections: types.maybeNull(types.frozen()),
    genericAnalysisId: types.maybeNull(types.string),
    languageUsed: types.maybeNull(types.string),
    schemaName: types.maybeNull(types.string),
    schemaSource: types.maybeNull(types.string),
  })
  .views((self) => ({
    get pdfDataParsed() {
      if (!self.sections) return null

      let sectionsParsed = JSON.stringify(self.sections)
      sectionsParsed = sectionsParsed.replace(/images\//g, 'assets/pdf-report/') 
      sectionsParsed = JSON.parse(sectionsParsed)
      return { sections: sectionsParsed }
    },
  }))
  .volatile((self) => ({
    _store: getRoot(self)[`${MODEL_NAME}Store`],
  }))

export default Model
